import AssetsManager from '../data/AssetsManager'
import EnvUtil from '../util/EnvUtil'


//２点間の距離
const tweet = (ogpText) =>
{
  //ShareするURL
  const ogpUrl = AssetsManager.getConfig().SHARE_URL;
  
  if(EnvUtil.isSmartPhone)
  {
    const url = "http://twitter.com/intent/tweet?text=" + decodeURI(ogpText+ogpUrl) + '&hashtags='+decodeURI('おぎわら遊技場')+","+decodeURI('DPZ');
    location.href = url;
    // window.open(url, 'win_t', 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=257, width=680');
  }
  else
  {
    const url = "http://twitter.com/share?url=" + ogpUrl + "&text=" + encodeURIComponent(ogpText) + '&amp;hashtags='+encodeURIComponent('おぎわら遊技場')+","+encodeURIComponent('DPZ');
    window.open(url, 'win_t', 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=257, width=680');
  }
}

const Share = {
  tweet: tweet,
}
export default Share